import { render, staticRenderFns } from "./POCreatedBanner.vue?vue&type=template&id=00840de2"
import script from "./POCreatedBanner.vue?vue&type=script&lang=ts"
export * from "./POCreatedBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports